import * as React from 'react';
import { FlourishEmbed } from '../../embed';
export var FlourishStory = function (props) {
    var description = props.description, link = props.link;
    var flourishId = link.replace('https://public.flourish.studio/story/', '').replace('/', '');
    var src = "https://flo.uri.sh/story/".concat(flourishId, "/embed");
    return (React.createElement(FlourishEmbed, { src: src, description: description }));
};
